import { createSlice } from '@reduxjs/toolkit';
import { resetAllSlices } from '../../Providers/mainStore.slice';

const initialState = {
  pendingDocs: [],
  selectedDocs: [],
};

const userSummarySlice = createSlice({
  name: 'userSummary',
  initialState,
  reducers: {
    setUserSummaryState: (state, action) => {
      return { ...state, ...action.payload };
    },
    setPendingDocs: (state, action) => {
      state.pendingDocs = action.payload;
    },
    setSelectedDocs: (state, action) => {
      state.selectedDocs = action.payload;
    },
    resetUserSummaryState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetAllSlices, () => {
      return initialState;
    });
  },
});

export const {
  setUserSummaryState,
  resetUserSummaryState,
  setPendingDocs,
  setSelectedDocs,
} = userSummarySlice.actions;

export default userSummarySlice.reducer;
